import React from 'react';
import { Grid } from '@wegroup/design-system';
import useFlowInputComponent from '../../../../hooks/useFlowsInputComponent';
import useQuestionEnum from '../../../../hooks/useQuestionEnum';
import { FlowsQuestion } from '../../../../types/FlowsTypes';
import MultiSelectWrapper from '../../../ui/advisory-flow/components/shared-components/MultiSelectWrapper';
import InterestsIconSelector from './InterestsIconSelector';
import SingleMultiSelectInput from './SingleMultiSelectInput';

interface Props {
  question: FlowsQuestion;
}

const MultiselectInputComponent: React.FC<React.PropsWithChildren<Props>> = ({
  question,
}) => {
  const {
    field: { value: selected, onBlur },
    error,
  } = useFlowInputComponent({ question, defaultValue: [] });

  const options = useQuestionEnum(question);

  const handleOnSingleSelected = (key: string) => {
    if (selected.includes(key))
      onBlur({
        name: question.id,
        value: selected.filter((_key: string) => key !== _key),
      });
    else
      onBlur({
        name: question.id,
        value: [...selected, key],
      });
  };

  const handleOnMultipleSelected = (items: string[]) => {
    onBlur({
      name: question.id,
      value: items,
    });
  };

  return (
    <MultiSelectWrapper
      question={question}
      selected={selected}
      onSelected={handleOnMultipleSelected}
      error={error?.message}
    >
      {/* <IconOptionWrapper data-test-id="ProdFac_MultiSelectInputComponent"> */}
      <Grid
        templateColumns={{
          base: 'repeat(2, minmax(13rem, 20rem))',
          tablet: 'repeat(3, minmax(13rem, 20rem))',
        }}
        gridGap="6"
      >
        {options.map(({ label, value }) => {
          return (
            <SingleMultiSelectInput
              key={`multi_select_${value}`}
              title={label}
              Icon={<InterestsIconSelector type={value} />}
              value={selected.includes(value)}
              onSelected={() => handleOnSingleSelected(value)}
            />
          );
        })}
      </Grid>
      {/* </IconOptionWrapper> */}
    </MultiSelectWrapper>
  );
};

export default MultiselectInputComponent;
